<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>

    <div v-else>
      <vx-card>
        <vs-table
          :max-items="descriptionItems[0]"
          pagination
          :data="contracts"
          description
          search
          @selected="handleViewContract"
          :description-items="descriptionItems"
          description-title="Registries"
          description-connector="of"
          description-body="Pages"
        >
          <template slot="header">
            <div class="list-heading">
              {{ $t("setup.label.ContractPeriod") }}
            </div>
            <div class="mr-2 mb-1 order-1">
              <vs-button
                @click="$router.push({ name: 'Create Contract' })"
                size="small"
                >{{ $t("setup.label.CreateContract") }}</vs-button
              >
            </div>
          </template>
          <template slot="thead">
            <vs-th>{{ $t("setup.label.ContractPeriod") }}</vs-th>
            <vs-th>{{ $t("setup.label.ContractType") }}</vs-th>
            <vs-th>{{ $t("setup.label.ContractUnit") }}</vs-th>
            <vs-th class="tHeadCenter">{{ $t("setup.label.Action") }}</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr
              :key="index"
              :data="contract"
              v-for="(contract, index) in contracts"
            >
              <vs-td :data="contract.period">{{
                contract.subscriptionPeriod
              }}</vs-td>
              <vs-td :data="contract.type">{{
                contract.subscriptionType
              }}</vs-td>
              <vs-td :data="contract.unit">{{ contract.units }}</vs-td>
              <vs-td class="whitespace-no-wrap">
                <div class="container_img">
                  <feather-icon
                    icon="EyeIcon"
                    :title="$t('setup.label.View')"
                    svgClasses="w-5 h-5 stroke-current cursor text-primary"
                    @click.stop="handleViewContract(contract)"
                    class="icon_row"
                  />
                  <feather-icon
                    icon="EditIcon"
                    :title="$t('setup.label.Edit')"
                    svgClasses="w-5 h-5 stroke-current orange_icon"
                    @click.stop="handleEditContract(contract.id)"
                    class="cursor-pointer icon_row"
                  />
                  <feather-icon
                    icon="TrashIcon"
                    :title="$t('setup.label.Delete')"
                    svgClasses="w-5 h-5 text-danger stroke-current"
                    @click.stop="
                      deleteContractPopup = true;
                      delId = contract.id;
                    "
                    class="cursor-pointer icon_row"
                  />
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <delete-popup
          :deletePopup="deleteContractPopup"
          :title="$t('Contract Period')"
          @deletePressed="deleteContractPeriod(delId)"
          @cancelPressed="deleteContractPopup = false"
        >
        </delete-popup>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex";

export default {
  data() {
    return {
      loading: false,
      descriptionItems: [10, 20, 30],
      deleteContractPopup: false,
    };
  },
  components: { AtomSpinner },
  computed: {
    ...mapState({
      contracts: (state) => state.contractPeriod.listContractPeriod,
    }),
  },
  methods: {
    async getContractPeriodList() {
      this.loading = true;
      try {
        this.$store.dispatch("contractPeriod/fetchContractPeriodList");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    handleEditContract(id) {
      this.$router.push({ name: "Edit Contract", params: { id: id } });
    },
    handleViewContract(contract) {
      this.$router.push({ name: "View Contract", params: { id: contract.id } });
    },
    async deleteContractPeriod(id) {
      try {
        this.deleteContractPopup = false;
        await this.$store.dispatch("contractPeriod/deleteContractPeriodAction", id);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Contract period Deleted Successfully!",
          type: "success",
        });
        this.getContractPeriodList();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mounted() {
    this.getContractPeriodList();
  },
};
</script>

<style></style>
